import React from 'react';

export default function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {/* 3 Copper Hexagons SVG */}
      <svg 
        width="58" 
        height="36" 
        viewBox="0 0 138 80" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        className="drop-shadow-[0_0_8px_rgba(184,115,51,0.5)]"
      >
        <defs>
          <linearGradient id="copperGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#7a431d" />
            <stop offset="30%" stopColor="#b87333" />
            <stop offset="50%" stopColor="#f2c79f" />
            <stop offset="70%" stopColor="#b87333" />
            <stop offset="100%" stopColor="#7a431d" />
          </linearGradient>
        </defs>
        
        {/* Small Hexagon */}
        <polygon points="14,46 26.1,53 26.1,67 14,74 1.9,67 1.9,53" fill="url(#copperGrad)" />
        
        {/* Medium Hexagon */}
        <polygon points="51,30 70.1,41 70.1,63 51,74 31.9,63 31.9,41" fill="url(#copperGrad)" />
        
        {/* Large Hexagon */}
        <polygon points="106,6 135.4,23 135.4,57 106,74 76.6,57 76.6,23" fill="url(#copperGrad)" />
      </svg>
      
      {/* Brand Text */}
      <span className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-white mt-1">
        GrowthRail
      </span>
    </div>
  );
}
